import React from 'react';
import { Flame, ThermometerSun, Snowflake } from 'lucide-react';

const CONFIGS = {
  hot: { icon: Flame, bg: 'bg-red-50', text: 'text-red-700', border: 'border-red-200', label: 'Hot' },
  warm: { icon: ThermometerSun, bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200', label: 'Warm' },
  cold: { icon: Snowflake, bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-200', label: 'Cold' },
};

export const LeadScoreBadge = ({ score, label, size = 'sm' }) => {
  const config = CONFIGS[label] || CONFIGS.cold;
  const Icon = config.icon;

  if (size === 'lg') {
    return (
      <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full ${config.bg} ${config.text} border ${config.border}`} data-testid={`lead-badge-${label}`}>
        <Icon className="h-4 w-4" />
        <span className="font-bold text-sm">{score}/100</span>
        <span className="text-xs font-medium">{config.label}</span>
      </div>
    );
  }

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`} data-testid={`lead-badge-${label}`}>
      <Icon className="h-3 w-3" />
      {score} {config.label}
    </span>
  );
};
